// @ts-nocheck
import styled from "styled-components";
import { Layout } from "antd"
import { LogoutOutlined } from '@ant-design/icons';
import { color } from "../../../resources";

const { Header } = Layout;

export const StyledLayoutHeader = styled(Header)`
    position: fixed;
    z-index: 9999;
    width: 100%;
    -webkit-box-shadow: 0 2px 5px ${color.overlay};
    -moz-box-shadow: 0 2px 5px ${color.overlay};
    box-shadow: 0 2px 5px ${color.overlay};
    background-color: ${color.header};
    height: 50px;
    align-items: center;
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
`

export const TextLogo = styled.div`
    font-size: ${props => props.isMobile ? '16px' : ' 20px'};
    font-family: Anuphan-Bold;
    color: ${props => props.color || '#FFFFFF'};
`

export const ButtonLogout = styled(LogoutOutlined)`
    color: ${props => props.color || '#FFFFFF'}
    font-size: 20px;
    margin-left: 10px;
`
